import React, {useEffect} from "react";
import CheckboxList from "../Checklist";
import styled from "styled-components"
import { markschemeTypeDictionary } from "../../helpers/pathDictionary";


const SectionHeading = styled.h2`
  font-weight: 500;
  margin-top: 40px;
  margin-bottom: 20px;
  font-size: 20px;
  margin-bottom: 0;
  background-color: #ecebff;
  padding: 3px 13px;
  display: inline-block;
  border-radius: 10git ppx;
`;

const SectionSubheading = styled.h2`
  font-size: 18px;
  text-indent: 15px;
  margin-top: 15px;
  text-decoration: underline;
  font-weight: 450;
`;

const OverridingChecklistComponent = ({
  section,
  updateSectionCheck,
  sectionCode,
  updateTotalSectionCheck,
  previousCode,
  setPreviousCode,
  checkboxClicked,
  disabled,
}) => {
  // useEffect(() => {
  //   var sectionCount = 0;
  //   section.points.forEach((point) => {
  //     sectionCount += 1;
  //     if (updateTotalSectionCheck) {
  //       updateTotalSectionCheck(sectionCode);
  //     }
  //   });
  //   //console.log(sectionCount);
  //   // if (updateTotalSectionCheck) {
  //   //   updateTotalSectionCheck(sectionCode, sectionCount);
  //   // }
  // }, []);

  return (
    <>
      <>
        {previousCode != sectionCode && (
          <SectionHeading>
            {markschemeTypeDictionary[sectionCode]}
          </SectionHeading>
        )}
        <>
          {section.title != null && section.title != "" ? (
            <>
              <SectionSubheading>{section.title}</SectionSubheading>
              <CheckboxList
                points={section.points}
                indented="true"
                updateSectionCheck={updateSectionCheck}
                sectionCode={sectionCode}
                checkboxClicked={checkboxClicked}
                disabled={disabled}
              />
            </>
          ) : (
            <>
              <CheckboxList
                disabled={disabled}
                points={section.points}
                updateSectionCheck={updateSectionCheck}
                sectionCode={sectionCode}
                checkboxClicked={checkboxClicked}
              />
            </>
          )}
        </>
      </>
    </>
  );
};

export default OverridingChecklistComponent;
